import RestBase from '@/services/base/RestBase'
import { ApiEnum } from '@/constants/ApiEnum'

export default class CartaoService extends RestBase {
    constructor() {
        super(ApiEnum.BACKEND, '/citsbe/recarga', 2);
    }
   
    async getUserByNumeroChip(numeroChip, cpf) {
        return this.get(`/solicitacaocarga/findCartaoByCodigoAntigoCpf/${numeroChip}/${cpf}`);
    }

    async getUserByCodCartao(codigoCartao, digitoCartao, cpf) {
        return this.get(`/solicitacaocarga/v2/findCartao/${codigoCartao}${digitoCartao}/0/${cpf}`);
    }

    async getListaPedidos(codigoCartao) {
        return this.get(`/solicitacaocarga/listaPedidos/${codigoCartao}`);
    }   

    async consultarFormaPagamentoSite(codigoCartao) {
        return this.get(`/carga/usuario/consultarFormaPagamentoSite/${codigoCartao}`);
    }   
    
    async novoPedidoWeb(pedido) {
        return this.post(`/carga/usuario/novopedidoweb`, pedido);
    }

    async salvar(dependente) {
        return this.put(`/dependente/update`, dependente);
    }
    
    async imprimirBoleto(cartaoSolicitacaoPedidoCarga) {
        return this.post(`/imprimirBoletoComRegistro`, cartaoSolicitacaoPedidoCarga);
    }

    async imprimirRecibo(cartaoSolicitacaoPedidoCarga) {
        return this.post(`/imprimirRecibo`, cartaoSolicitacaoPedidoCarga);
    }

    async consultarMetodoCompra(codigoCartao) {
        return this.get(`/carga/usuario/consultarMetodoCompra/${codigoCartao}`);
    }
    
    async gerarTxId(tipo) {
        return this.get(`/carga/usuario/gerarTxId/${tipo}`);
    }    

    async registrarTxIdPedido(data) {
        return this.post(`/carga/usuario/registrarTxIdPedido`, data);
    }
}